import React from 'react';
import { CompareMetric, formatMetricValue, capPercentChange, getCardModifier } from './compareUtils';

interface CompareKpiCardProps {
  metric: CompareMetric;
  range1Value: number;
  range2Value: number;
  percentChange: number | null;
  isSelected: boolean;
  onClick: () => void;
}

const CompareKpiCard: React.FC<CompareKpiCardProps> = ({
  metric,
  range1Value,
  range2Value,
  percentChange,
  isSelected,
  onClick,
}) => {
  const isDisabled = range1Value === 0 && range2Value === 0;
  const colorModifier = getCardModifier(percentChange, metric.higherIsBetter);

  const changeClass = [
    'compare-kpi-change',
    colorModifier === 'compare-kpi-card--positive' ? 'compare-kpi-change--positive'
      : colorModifier === 'compare-kpi-card--negative' ? 'compare-kpi-change--negative'
      : 'compare-kpi-change--neutral',
  ].join(' ');

  const cardClass = [
    'compare-kpi-card',
    isDisabled ? 'compare-kpi-card--disabled' : colorModifier,
    isSelected ? 'compare-kpi-card--selected' : '',
  ].filter(Boolean).join(' ');

  const arrow = percentChange === null || percentChange === 0
    ? ''
    : percentChange > 0 ? '↑ ' : '↓ ';

  return (
    <div
      className={cardClass}
      onClick={isDisabled ? undefined : onClick}
      role={isDisabled ? undefined : 'button'}
      tabIndex={isDisabled ? undefined : 0}
      onKeyDown={isDisabled ? undefined : (e) => e.key === 'Enter' && onClick()}
    >
      <h6 className="text-uppercase mb-1 compare-kpi-title">{metric.label}</h6>
      <div className="compare-kpi-main-row">
        <h4 className="mb-0 fw-bold">{formatMetricValue(range1Value, metric.format)}</h4>
        <span className={changeClass}>
          {arrow}{capPercentChange(percentChange)}
        </span>
      </div>
      <small className="text-muted">
        Prev: {formatMetricValue(range2Value, metric.format)}
      </small>
    </div>
  );
};

export default CompareKpiCard;
